import styled from "styled-components";

import { FlexColumn } from "@similarweb/ui-components";

export const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const Container = styled(FlexColumn)`
    height: 100%;
    justify-content: space-between;
    gap: 24px;
`;
export const FooterContainer = styled.div`
    margin-bottom: 20px;
`;
